import app, { Component } from 'apprun';
import { companies as objApi } from './api';
import { showSaveStatusMessage, lookup_en, isStringEqual } from './utils';

import PropEditorTextComponent from './common-props/common-props-text-edit';
import PropEditorAddressComponent from './common-props/common-props-address-edit';
import PropEditorPhoneComponent from './common-props/common-props-phone-edit';
import PropEditorSelectionComponent from './common-props/common-props-selection-edit';
import PropEditorDateComponent from './common-props/common-props-date-edit';
import CompanyPropertyAwardComponent from './company-props/company-props-award';
import CompanyPropertySmartLeadComponent from './company-props/company-props-smartlead';
import CompanyPropertyReportComponent from './company-props/company-props-report-edit';

///* eslint-disable */

const objName = 'company',
  objectTypeId = 1;

export default class CompanyComponent extends Component {
  getItemValue(item) {
    if (!item) {return;}
    let itemValue = item.value;
    let selectOptions;
    switch (item.fieldType) {
    case null:
    case 'CALL':
    case 'Text':
      return itemValue;
    case 'Phones':
    case 'html':
      return item.value
        ? item.value.split('<BR/>').map(p => (
          <span>
            {p}
            <br />
          </span>
        ))
        : '';
    case 'DateStr':
      return item.value ? new Date(item.value).toDateString() : null;
    case 'Int':
      if (itemValue === '-1' && item.fieldTypeDetail) {itemValue = 'Not Available';}
      return itemValue;
    case 'Selection':
      if (item.fieldTypeDetail && item.fieldTypeDetail.startsWith('[')) {
        selectOptions = JSON.parse(item.fieldTypeDetail);
      } else {
        selectOptions = lookup_en[item.fieldTypeDetail];
      }
      selectOptions = selectOptions || [];
      const selectedOption = selectOptions.filter((p) => {
        return isStringEqual(p.id, itemValue);
      })[0];

      itemValue = selectedOption ? selectedOption.value : item.value;
      return itemValue;
    case 'Award':
      return itemValue.replace(' >> ', ' ');
    case 'SmartLead':
      return itemValue;
    default:
      return itemValue;
    }
  }

  Item = ({ item, editing }) => {
    if (!item || !item.displayOrder) {return;}
    return (
      <td>
        <label class="control-label col-sm-5">
          {item.dispName}{' '}
          {item.editable ? (
            ''
          ) : (
            <span>
              {' '}
              &nbsp; <i class="fa fa-lock" />{' '}
            </span>
          )}
        </label>
        <div class="form-text col-sm-5">{this.getItemValue(item)}</div>
        <div class="col-sm-2 text-right">
          {editing ? <i class="control-label glyphicon glyphicon-pencil" /> : ''}
        </div>
      </td>
    );
  };

  List = ({ state }) => (
    <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover">
      <tbody>
        {state.props
          .filter(p => p.fieldType === 'Group' || p.dispName.toUpperCase().indexOf(state.filter.toUpperCase()) >= 0)
          .map((item) => {
            return (
              <tr
                style={{ display: 'table-row' }}
                data-displayOrder={item.displayOrder}
                onclick={(e) => {
                  if (item.fieldType !== 'Group') {this.run('edit-prop', item, e);}
                }}>
                <this.Item item={item} editing={state.editingItem && item.fieldName === state.editingItem.fieldName} />
              </tr>
            );
          })}
      </tbody>
    </table>
  );

  state = { filter: '', editingItem: null, props: [] };

  view = (state) => {
    if (!state || !state.company) {return;}

    return (
      <div>
        <div class="row">
          <button onclick={() => this.run('start-jumpSync')} disabled={(this.getItem('ForceSyncButton') || {}).editable?'':'disabled'}>Jump Sync</button>
        </div>
        <div class="list-group" style={{ width: '500px' }}>
          <div style={{ 'white-space': 'normal', 'word-wrap': 'break-word' }}>
            <this.List state={state} />
          </div>
          <a class="row list-group-item" href={`#location-list/${state.companyId}`}>
            Locations <span class="badge">{(this.getItem('LocationsCount') || {}).value}</span>
          </a>
          <a class="row list-group-item" href={`#team-list/${state.companyId}`}>
            Teams<span class="badge">{(this.getItem('TeamsCount') || {}).value}</span>
          </a>
          <a class="row list-group-item" href={`#user-list/${state.companyId}/0/users`}>
            Users<span class="badge">{(this.getItem('UsersCount') || {}).value}</span>
          </a>
        </div>
      </div>
    );
  };

  update = {
    refresh: async (state, companyId) => {
      const company = await objApi.getCompanyDetail(companyId);
      const hasFullAccess = company.hasFullAccess;
      state.props = company.companyDetail;
      this.addReportItem(state);
      state.props.sort(function (a, b) {
        return a.orderA2Z - b.orderA2Z;
      });
      state.props.forEach(item => (item.displayOrder = item.orderA2Z));
      state = this.sortGroupwise(state);
      return { ...state, companyId, company, editingItem: null, props: company.companyDetail, hasFullAccess };
    },

    'edit-prop': (state, item, e) => {
      if (!item.editable) {return;}
      e.preventDefault();
      state.editingItem = item;

      const panelId = 'prop-edit-' + item.fieldType;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let editorState: any = {
        item,
        panelId,
        caller: this,
        cancel: 'edit-prop-cancel',
        save: 'save-prop',
        delete: 'delete-prop',
      };

      let comp;
      switch (item.fieldType) {
      case 'Address':
        comp = PropEditorAddressComponent;
        editorState = { ...editorState, addressId: state.companyId, objectTypeId };
        break;
      case 'Phones':
        comp = PropEditorPhoneComponent;
        editorState = { ...editorState, phoneId: state.companyId, objectTypeId };
        break;
      case 'Report':
        comp = CompanyPropertyReportComponent;
        editorState.companyId = state.companyId;
        break;
      case 'Selection':
        comp = PropEditorSelectionComponent;
        break;
      case 'DateStr':
        comp = PropEditorDateComponent;
        break;
      case 'Award':
        comp = CompanyPropertyAwardComponent;
        break;
      case 'SmartLead':
        comp = CompanyPropertySmartLeadComponent;
        editorState = { ...editorState, companyId: state.companyId };
        break;
      default:
        comp = PropEditorTextComponent;
        break;
      }
      app.run('#add-panel', { id: panelId, title: item.dispName, Component: comp, state: editorState, level: 4 });
    },

    'save-prop': async (state, item, panelId, newVal) => {
      if(item.fieldType==='Report'){
        objApi.getRpt(state.companyId, newVal);
        this.run('edit-prop-cancel', panelId);
        return;
      }
      try{
        if (panelId === 'prop-edit-Address' || panelId === 'prop-edit-Phones') {
          this.run('edit-prop-cancel', panelId);
          this.run('refresh', state.companyId);
        } else {
          const result = await objApi.upsertProperty(state.companyId, { prop: item, newValue: newVal });
          showSaveStatusMessage('company');
          if (result) {
            item.value = newVal;
            this.run('edit-prop-cancel', panelId);
          }
        }
      }catch{showSaveStatusMessage();}

    },

    'delete-prop': async (state, item, panelId) => {
      const result = await objApi.deleteProperty(state.companyId, item);
      showSaveStatusMessage('company');
      if (result) {
        if (item.multiValue) {
          state.props.splice(state.props.indexOf(item), 1);
        } else {
          item.value = '';
        }
        this.run('edit-prop-cancel', panelId);
      }
    },

    'edit-prop-cancel': (state, id) => {
      state.editingItem = null;
      app.run('#clear-panel', id);
      return state;
    },

    'start-jumpSync': async (state) => {
      await objApi.initiateForceSync(state.companyId);
      showSaveStatusMessage('Jump Sync');
    },
  };

  // TODO
  getItem = fieldName => this.state.props.find(p => p.fieldName === fieldName);

  updateObj =  async (state) => {
    const result = await objApi.post(state.companyId, state[objName]);
    showSaveStatusMessage(result);
    return result;
  }

  addReportItem = (state) => {
    const rptItem = { 'fieldName':'SavedInv','dispName':'Saved Invoices','value':'Select Month','fieldType':'Report',
      'orderA2Z':10100,'orderScheme1':10190,'multiValue':false,'editable':true,'required':true };
    state.props.push(rptItem);
  }

  mounted = ({ state }) => {
    this.run('refresh', state.companyId);
  }

  sortGroupwise = (state) => {
    state.props.sort(function (a, b) {
      return(a.orderScheme1 ?? 0) - (b.orderScheme1 ?? 0);
    });
    state.props.forEach(item => (item.displayOrder = item.orderScheme1));
    state.mode = 'group';
    return state;
  }
}
